import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { BairrosDisponiveisFiltro, ImoveisDisponiveisFiltro, ImoveisDisponiveisResponse, ImovelDetalhes, ImovelDetalhesResposta, LeadModel, ListaItensCondominio } from '../../model/integracao';
import { IntegracaoService } from '../../services/integracao.service';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { GoogleMapsModule } from '@angular/google-maps';
import { VideoImovelComponent } from '../video-imovel/video-imovel.component';
import { MatDialog } from '@angular/material/dialog';
import { ImagensComponent } from '../imagens/imagens.component';
import { CondominioDetalhe } from '../../model/imovel';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CondominioService } from '../../services/condominio.service';
import { CondominioResponseDto } from '../../dto/condominio-response.dto';
import { LoaderComponent } from '../../components/loader/loeader.component';
import { BuscaService, FetchResponse } from '../../services/busca.service';
import { BuscaAvancadaFilter } from '../../model/busca-avancada-filter.model';
import { ImovelResponseDto } from '../../dto/imovel-response.dto';
import { ComodidadesComponent } from '../../components/comodidades/comodidades.component';
import { EnderecoImovelPipe } from '../../pipes/endereco-imovel.pipe';
import { DeveExibirAtributoPipe } from '../../pipes/deve-exibir-atributo';
import { SwiperImagensComponent } from '../../components/swiper-imagens/swiper-imagens.component';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-detalhes-condominio',
  standalone: true,
  imports: [CommonModule, GoogleMapsModule, ReactiveFormsModule, LoaderComponent, ComodidadesComponent, EnderecoImovelPipe, DeveExibirAtributoPipe, SwiperImagensComponent],
  templateUrl: './detalhes-condominio.component.html',
  styleUrl: './detalhes-condominio.component.scss'
})


export class DetalhesCondominioComponent {
  public isLoading: boolean = false;

  imagemCorretor: string = ''
  nomeCorretor: string = ''
  imoveis: ImovelDetalhes[] = [];
  imovel: ImovelDetalhes | undefined;
  mobile: boolean = false
  filtro: ImoveisDisponiveisFiltro = {
    finalidade: 1,
    codigoDestinacao: 0,
    destaque: 0,
    opcaoImovel: 0,
    codigoUnidade: '',
    codigoCondominio: 0,
    codigoProprietario: 0,
    codigoCaptador: 0,
    codigosImoveis: '',
    codigoTipo: '',
    estado: '',
    codigoCidade: 0,
    codigoRegiao: 0,
    codigoSubRegiao: 0,
    codigosBairros: '',
    endereco: '',
    edificio: '',
    numeroQuartos: 0,
    numeroSuites: 0,  // Adicionado, pois estava no primeiro objeto
    numeroVagas: 0,
    numeroBanhos: 0,
    numeroVaranda: 0,
    numeroElevador: 0,
    valorDe: 0,
    valorAte: 0,
    areaPrincipalDe: 0,
    areaPrincipalAte: 0,
    areaDe: '0',
    areaAte: '0',
    areaExternaDe: '0',
    areaExternaAte: '0',
    ordenacao: '', // Deixado como string vazia para manter consistência
    numeroPagina: 1, // Deixado para receber dinamicamente
    numeroRegistros: 20, // Deixado para receber dinamicamente
    aceitaFinanciamento: false, // Mantendo consistência com `this.selectedFinanciamento`
    naPlanta: false,
    retornoMapa: false
  };
  itensCondominio: ListaItensCondominio = {
    minArea: 0,
    maxArea: 0,
    minVagas: 0,
    maxVagas: 0,
    quartosUnicos: []
  };
  caracteristicas: any = []
  condominio: CondominioDetalhe | undefined;
  groupedFotos: any[] = [];
  private apiKey = 'AIzaSyCih4iTaq5A2XMnkCxuKFAfbJUPeOvKp28'; // 🔹 Substitua pela sua chave real
  private map!: google.maps.Map;
  private mapLoaded = false;
  imoveisFiltrado: any[] = [];
  existeVideo: boolean = false;
  leadForm: FormGroup;
  isSubmitting = false;
  condominio2: CondominioResponseDto | undefined;
  buscaAvancadaFilter: BuscaAvancadaFilter
  public buscaResponse: FetchResponse;
  public imoveis2: ImovelResponseDto[] = [];
  public message: string | null = null;
  public quantidade2: number = 0;
  gridState: 'default' | 'filter-open' | 'overlay-opened' = 'default';
  pageIndex = 2;
  isOverlayOpen = false;


  constructor
    (
      public dialog: MatDialog,
      private integracaoService: IntegracaoService,
      @Inject(PLATFORM_ID) private platformId: Object,
      private route: ActivatedRoute,
      private router: Router,
      private fb: FormBuilder,
      private condominioService: CondominioService,
      private buscaService: BuscaService,
      private titleService: Title
    ) {
    this.leadForm = this.fb.group({
      nome: ['', Validators.required],
      telefone: ['', Validators.required], // Formato (XX) XXXXX-XXXX
      email: ['', [Validators.email]],
      midia: [{ value: 'Site Cancian', disabled: true }], // Sempre fixo
      codigoImovel: [''], // 🔹 Código do imóvel dinâmico
    });
  }


  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.checkMobile();
      if (typeof window !== 'undefined') {
        window.addEventListener('resize', this.checkMobile.bind(this));
      }

      // 🔹 Garante que o scroll acontece depois da renderização
      setTimeout(() => {
        window.scrollTo(0, 0);
      });

      // 🔹 Faz o scroll ao navegar entre páginas
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          setTimeout(() => {
            window.scrollTo(0, 0);
          });
        }
      });
    }
    const idCondominio = this.route.snapshot.paramMap.get('idC');
    if (idCondominio) {
      // this.buscarImoveis(idCondominio);
      this.buscarCondominio2(idCondominio);
      this.buscarImoveis2(idCondominio);
    }
  }

  checkMobile() {
    if (typeof window !== 'undefined') {
      this.mobile = window.innerWidth < 935;
    }
  }

  async buscarCondominio2(codigoCond: any): Promise<void> {
    // Buscar detalhes do condomínio
    this.isLoading = true;
    try {
      this.condominio2 = await this.condominioService.getByCode(codigoCond);
      if (this.condominio2) {
         this.titleService.setTitle(this.condominio2.nome + '- Cancian Imóveis');

        if (this.condominio2.imagens && this.condominio2.imagens.length > 0) {
          const numeroAgrupar = this.mobile ? 1 : 3;
          this.groupedFotos = this.groupBy(this.condominio2.imagens, numeroAgrupar);
        }
      } else {
        console.warn('Nenhum condomínio encontrado com o código:', codigoCond);
        alert('Nenhum condomínio encontrado com o código informado.');
        this.router.navigate(['/']);
      }
      //this.isLoading = false;

    } catch (error) {
      console.error('Erro ao buscar detalhes do condomínio:', error);
      alert('Erro ao buscar detalhes do condomínio. Tente novamente mais tarde.');
      this.router.navigate(['/']);
      //this.isLoading = false;
    }
  }

  buscarImoveis2(codigoCond: any): void {
    this.isLoading = true;
    // Configurar o filtro para busca avançada
    this.route.queryParams.subscribe(params => {
      this.pageIndex = params['page'] ? +params['page'] : 1; // Pega o parâmetro de página da URL ou define como 1
    });
    this.filtro.codigoCondominio = codigoCond;
    this.filtro.numeroPagina = this.pageIndex;

    this.buscaAvancadaFilter = {
      id_condominio: codigoCond,
      page: this.pageIndex,
    };
    const buscaSub = this.buscaService.fetch(this.buscaAvancadaFilter).subscribe({
      next: (res) => {
        const { items, total } = res;
        this.buscaResponse = res;

        this.quantidade2 = total ?? 0;




        if (items.length === 0) {
          this.imoveis2 = [];
          this.message = 'Nenhum resultado encontrado';
        } else {
          this.imoveis2 = items;
          this.message = null;
        }

        this.itensCondominio = this.getEstatisticasImoveis();
        this.carregarScriptGoogleMaps();

        if (this.mapLoaded) {
          this.initMap();
        }
      },
      error: console.error,
      complete: () => (this.isLoading = false)
    });
  }

  buscarImoveis(codigoCond: any): void {
    this.isLoading = true;
    const filtroAluguel = { ...this.filtro, finalidade: 0, codigoCondominio: codigoCond };

    // Buscar imóveis disponíveis para aluguel
    this.integracaoService.postImoveisDisponiveis(filtroAluguel).subscribe({
      next: (data: ImoveisDisponiveisResponse) => {
        this.isLoading = false;

        if (data?.lista?.length > 0) {
          this.imoveis = data.lista;

          // Atualiza informações do corretor, pegando o último captador (se houver)
          const ultimoCaptador = this.imoveis[0].captadores?.slice(-1)[0];
          if (ultimoCaptador) {
            this.imagemCorretor = ultimoCaptador.foto;
            this.nomeCorretor = ultimoCaptador.nome;
          }

          // Verifica se há um vídeo disponível
          this.existeVideo = !!this.imoveis[0].urlVideo?.trim();

          this.caracteristicas = this.getCaracteristicasValidas();
          this.itensCondominio = this.getEstatisticasImoveis();
          this.carregarScriptGoogleMaps();

          if (this.mapLoaded) {
            this.initMap();
          }
        } else {
          console.warn('Nenhum imóvel encontrado para aluguel.');
          this.imoveis = [];
        }
      },
      error: (error) => {
        console.error('Erro ao buscar imóveis para aluguel:', error);
        this.handleError(error);
      },
    });
  }


  getEstatisticasImoveis() {
    if (!this.imoveis2 || this.imoveis2.length === 0) {
      return {
        minArea: 0,
        maxArea: 0,
        minVagas: 0,
        maxVagas: 0,
        quartosUnicos: [] as number[]
      };
    }

    // 🔹 Extrair valores e garantir que sejam números válidos
    const areas = this.imoveis2
      .map(imovel => Number(imovel.area_privativa))
      .filter(val => !isNaN(val) && val > 0);

    const vagas = this.imoveis2
      .map(imovel => Number(imovel.garagens))
      .filter(val => !isNaN(val) && val >= 0);

    const quartos = this.imoveis2
      .map(imovel => Number(imovel.dormitorios))
      .filter(val => !isNaN(val) && val > 0);

    return {
      minArea: areas.length > 0 ? Math.min(...areas) : 0,
      maxArea: areas.length > 0 ? Math.max(...areas) : 0,
      minVagas: vagas.length > 0 ? Math.min(...vagas) : 0,
      maxVagas: vagas.length > 0 ? Math.max(...vagas) : 0,
      quartosUnicos: [...new Set(quartos)].sort((a, b) => a - b)
    };
  }

  formatarQuartos(quartos: number[]): string {
    if (quartos.length === 1) {
      return `${quartos[0]}`;
    } else {
      return quartos.slice(0, -1).join(', ') + ' e ' + quartos[quartos.length - 1];
    }
  }



  getCaracteristicasValidas(): string[] {
    if (!this.imoveis || this.imoveis.length === 0) {
      return [];
    }

    const imovel = this.imoveis[0] as Record<string, any>; // Força o TypeScript a aceitar acesso dinâmico
    const caracteristicasValidas: string[] = [];

    // 🔹 Dicionário de mapeamento: Chaves são os nomes técnicos, valores são os nomes amigáveis para o cliente
    const caracteristicasMap: Record<string, string> = {
      "arCondicionado": "Ar Condicionado",
      "areaServico": "Área de Serviço",
      "areaPrivativa": "Área Privativa",
      "armarioBanheiro": "Armário no Banheiro",
      "armarioCozinha": "Armário na Cozinha",
      "armarioQuarto": "Armário no Quarto",
      "box": "Box no Banheiro",
      "closet": "Closet",
      "dce": "Dependência de Empregada",
      "despensa": "Despensa",
      "escritorio": "Home Office",
      "lavabo": "Lavabo",
      "mobiliado": "Mobiliado",
      "rouparia": "Roupeiro",
      "aguaIndividual": "Hidrômetro Individual",
      "alarme": "Alarme",
      "aquecedorGas": "Aquecedor a Gás",
      "aquecedorEletrico": "Aquecedor Elétrico",
      "aquecedorSolar": "Aquecedor Solar",
      "boxDespejo": "Box de Despejo",
      "cercaEletrica": "Cerca Elétrica",
      "circuitoTV": "Circuito de TV",
      "gasCanalizado": "Gás Canalizado",
      "interfone": "Interfone",
      "jardim": "Jardim",
      "lavanderia": "Lavanderia",
      "portaoEletronico": "Portão Eletrônico",
      "portaria24Horas": "Portaria 24h",
      "seguranca24Horas": "Segurança 24h",
      "quintal": "Quintal",
      "gramado": "Gramado",
      "academia": "Academia",
      "churrasqueira": "Churrasqueira",
      "hidromassagem": "Hidromassagem",
      "homeCinema": "Home Cinema",
      "piscina": "Piscina",
      "playground": "Playground",
      "quadraEsportiva": "Quadra Esportiva",
      "quadraTenis": "Quadra de Tênis",
      "salaMassagem": "Sala de Massagem",
      "salaoFestas": "Salão de Festas",
      "salaoJogos": "Salão de Jogos",
      "sauna": "Sauna",
      "wiFi": "Wi-Fi",
      "espacoGourmet": "Espaço Gourmet",
      "garageBand": "Garage Band",
      "quadraSquash": "Quadra de Squash",
      "beachTenis": "Quadra de Beach Tênis",
      "solManha": "Sol da Manhã",
      "vistaMar": "Vista para o Mar",
      "varandaGourmet": "Varanda Gourmet",
      "lareira": "Lareira",
      "cabeamentoEstruturado": "Cabeamento Estruturado",
      "tVaCabo": "TV a Cabo",
      "conexaoInternet": "Conexão com Internet",
      "vistaMontanha": "Vista para Montanha",
      "vistaLago": "Vista para o Lago",
      "permiteAnimais": "Permite Animais"
    };

    // 🔹 Iterar sobre as propriedades e verificar quais são `true`
    Object.keys(caracteristicasMap).forEach((prop) => {
      if (imovel[prop]) {
        caracteristicasValidas.push(caracteristicasMap[prop]); // Pegamos o nome amigável
      }
    });

    return caracteristicasValidas;
  }


  // Tratamento de erros
  private handleError(error: any): void {
    if (error.status === 400) {
      console.error('Erro de validação: Verifique os dados enviados.', error.message);
    } else if (error.status === 500) {
      console.error('Erro interno no servidor. Tente novamente mais tarde.', error.message);
    } else {
      console.error('Erro inesperado:', error.message);
    }
  }


  groupBy(array: any[], size: number): any[] {
    const grouped = [];
    for (let i = 0; i < array.length; i += size) {
      grouped.push(array.slice(i, i + size));
    }
    return grouped;
  }

  abreImovel(idImovel: any): void {
    this.router.navigate(['/imovel', idImovel]);
  }


  carregarScriptGoogleMaps(): void {
    if (document.getElementById('google-maps-script')) {
      this.mapLoaded = true;
      this.initMap();
      return;
    }

    const script = document.createElement('script');
    script.id = 'google-maps-script';
    script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}`;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      this.mapLoaded = true;
      if (this.imoveis) {
        this.initMap();
      }
    };
    document.body.appendChild(script);
  }


  initMap(): void {
    if (typeof document !== 'undefined') {
      this.imoveisFiltrado = this.imoveis2.map(imovel => ({
        latitude: imovel.latitude,
        longitude: imovel.longitude,
        titulo: imovel.titulo,
        tipo: imovel.tipo,
        destinacao: imovel.contrato,
        endereco: imovel.endereco_logradouro,
        bairro: imovel.endereco_bairro,
        cidade: imovel.endereco_cidade,
        estado: imovel.endereco_estado,
        valor: imovel.valor_venda || imovel.valor_locacao,
        areaPrincipal: imovel.area_privativa,
        numeroQuartos: imovel.dormitorios,
        numeroBanhos: imovel.banheiros,
        numeroVagas: imovel.garagens,
        fotos: imovel.imagens[0].link_thumb || '',
        codigo: imovel.codigo
      }));

      const mapElement = document.getElementById('map');
      if (mapElement) {
        this.map = new google.maps.Map(mapElement as HTMLElement, {
          mapTypeControl: false,
          streetViewControl: false,
        });
      } else {
        console.error("Elemento 'map' não encontrado!");
      }

      const bounds = new google.maps.LatLngBounds();

      this.imoveisFiltrado.forEach((local) => {
        const latLng = new google.maps.LatLng(local.latitude, local.longitude);
        bounds.extend(latLng);
        this.adicionarMarcador(local);
      });
      if (this.imoveisFiltrado.length > 0) {
        setTimeout(() => {
          this.map.fitBounds(bounds);

          // Se o zoom ficar muito amplo, aplica um limite
          const listener = google.maps.event.addListener(this.map, "idle", () => {
            if (this.map && this.map.getZoom() !== undefined) {
              this.map.setZoom(15); // Define um zoom máximo para evitar um mapa muito afastado
            }
            google.maps.event.removeListener(listener);
          });
        }, 500);
      }

    }
  }

  removeExitFullscreenButton(exitFullscreenBtn: HTMLElement) {
    if (!this.map) return;

    const controls = this.map.controls[google.maps.ControlPosition.TOP_RIGHT];
    const index = controls.getArray().indexOf(exitFullscreenBtn);

    if (index > -1) {
      controls.removeAt(index);
    }
  }

  setupFullscreenToggle() {
    const exitFullscreenBtn = document.getElementById("exit-fullscreen-btn");

    // Mostrar o botão somente quando estiver em tela cheia
    document.addEventListener("fullscreenchange", () => {
      if (document.fullscreenElement) {
        exitFullscreenBtn!.style.display = "block";
      } else {
        exitFullscreenBtn!.style.display = "none";
      }
    });
  }


  adicionarMarcador(local: {
    latitude: number; longitude: number; titulo: string; tipo: string; destinacao: string;
    endereco: string; bairro: string; cidade: string; estado: string; valor: string;
    areaPrincipal: string; numeroQuartos: string; numeroBanhos: string; numeroVagas: string;
    fotos: string; codigo: string;
  }): void {
    if (typeof document !== 'undefined') {
      const tamanhoAmpliado = new google.maps.Size(47, 47);
      const tamanhoNormal = new google.maps.Size(45, 45);
      const urlIcone = "../../assets/pin-cancian.png";

      const marcador = new google.maps.Marker({
        position: { lat: local.latitude, lng: local.longitude },
        map: this.map,
        title: local.titulo,
        icon: {
          url: urlIcone,
          scaledSize: tamanhoNormal,
        }
      });

      // Efeito hover no marcador
      marcador.addListener('mouseover', () => {
        marcador.setIcon({
          url: urlIcone,
          scaledSize: tamanhoAmpliado,
        });
      });

      marcador.addListener('mouseout', () => {
        marcador.setIcon({
          url: urlIcone,
          scaledSize: tamanhoNormal,
        });
      });

    }
  }


  abreApresentacao() {
    if (this.existeVideo && this.imoveis[0].urlVideo) {
      this.dialog.open(VideoImovelComponent, {
        width: this.mobile ? '90vw' : '1260px',
        height: this.mobile ? '250px' : '700px',
        maxWidth: '90vw',
        maxHeight: '90vh',
        data: { url: this.imoveis[0].urlVideo },
        disableClose: false,
        autoFocus: false,
        hasBackdrop: true, // Mantém o fundo escuro ativo
        panelClass: 'custom-dialog-container',
        backdropClass: 'custom-backdrop' // Aplica o fundo escurecido
      });
    } else {
      alert("Vídeo indisponível");
    }
  }

  abreGaleria() {
    if (this.imoveis[0].fotos && this.imoveis[0].fotos.length > 0) {
      this.dialog.open(ImagensComponent, {
        width: '100vw', // 🔹 Define a largura como 90% da tela
        height: '100vh', // 🔹 Define a altura como 90% da tela
        maxWidth: '100vw',
        maxHeight: '100vh',
        data: { imagens: this.imoveis[0].fotos.map(f => f.urlM) },
        disableClose: false,
        autoFocus: false,
        hasBackdrop: true,
        panelClass: 'custom-dialog-container',
        backdropClass: 'custom-backdrop'
      });
    } else {
      alert("Nenhuma imagem disponível");
    }
  }

  addFullscreenControl() {
    const fullscreenBtnDesktop = document.getElementById("fullscreen-map-btn-desktop");
    const fullscreenBtnMobile = document.getElementById("fullscreen-map-btn-mobile");

    const toggleFullscreen = () => {
      const mapElement = document.getElementById("map") as HTMLElement;

      if (!document.fullscreenElement) {
        if (mapElement.requestFullscreen) {
          mapElement.requestFullscreen();
        }
      }
    };

    if (fullscreenBtnDesktop) {
      fullscreenBtnDesktop.addEventListener("click", toggleFullscreen);
    }
    if (fullscreenBtnMobile) {
      fullscreenBtnMobile.addEventListener("click", toggleFullscreen);
    }

    this.addExitFullscreenButtonToMap();
  }
  addExitFullscreenButtonToMap() {
    if (!this.map) return;

    const existingControls = this.map.controls[google.maps.ControlPosition.TOP_RIGHT];
    if (existingControls.getArray().some(control => control instanceof HTMLButtonElement)) {
      return;
    }

    const exitFullscreenBtn = document.createElement("button");
    exitFullscreenBtn.innerHTML = "Fechar Mapa ✖";
    exitFullscreenBtn.className = "exit-fullscreen";
    exitFullscreenBtn.style.padding = "10px 15px";
    exitFullscreenBtn.style.fontSize = "16px";
    exitFullscreenBtn.style.background = "rgba(0, 0, 0, 0.8)";
    exitFullscreenBtn.style.color = "white";
    exitFullscreenBtn.style.border = "none";
    exitFullscreenBtn.style.borderRadius = "5px";
    exitFullscreenBtn.style.cursor = "pointer";

    exitFullscreenBtn.addEventListener("click", () => {
      if (document.fullscreenElement && document.exitFullscreen) {
        document.exitFullscreen();
      }
    });

    document.addEventListener("fullscreenchange", () => {
      if (document.fullscreenElement) {
        if (!existingControls.getArray().includes(exitFullscreenBtn)) {
          this.map.controls[google.maps.ControlPosition.TOP_RIGHT].push(exitFullscreenBtn);
        }
      } else {
        this.removeExitFullscreenButton(exitFullscreenBtn);
      }
    });
  }
  openWhatsApp(): void {
    this.enviarLead();
    const phone = this.getFormattedPhone();
    const message = encodeURIComponent("Olá! Gostaria de mais informações.");
    const whatsappUrl = `https://wa.me/${phone}?text=${message}`;
    window.open(whatsappUrl, '_blank');
  }
  getFormattedPhone(): string {
    return `555530337400`; // Adiciona código do Brasil (55)
  }
  enviarLead() {
    if (this.leadForm.invalid) {
      alert("Preencha os campos obrigatórios corretamente!");
      return;
    }

    this.isSubmitting = true;

    const leadData: LeadModel = {
      ...this.leadForm.value,
      midia: 'Site Cancian', // Garantindo o valor fixo
      codigoImovel: this.imovel!.codigo.toString(),
      anotacoes: 'Pagina do Condominio, id (' + this.condominio!.codigo.toString() + ') foi feito contato através do site(Informação adicional).'
    };

    this.integracaoService.postNovoLead(leadData).subscribe({
      next: () => {
        alert("Cadastro realizado com sucesso!");
        this.leadForm.reset();
      },
      error: (err) => {
        console.error('Erro ao enviar lead:', err);
        alert("Erro ao cadastrar lead. Tente novamente.");
      },
      complete: () => {
        this.isSubmitting = false;
      }
    });
  }


  previousPage(): void {
    const currentPage = this.buscaResponse.page;

    if (currentPage > 0) {
      const page = currentPage - 1;
      this.navigateToPage(page);
    }
  }

  nextPage(): void {
    const page = this.buscaResponse.page + 1;
    this.navigateToPage(page);
  }
  async navigateToPage(page: number) {
    this.pageIndex = page; // Atualiza a página atual
    await this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { page },
      queryParamsHandling: 'merge' // mantém os outros parâmetros
    });

    this.buscarImoveis2(this.condominio2?.codigo); // Recarrega os imóveis com a nova página
  }

  //pageIndex = 1;
  newPageIndex = 1;
  getPages(): number[] {
    const totalPaginas = this.buscaResponse?.totalPages;

    if (totalPaginas <= 1) return [1]; // Apenas uma página disponível

    const pagesArray: number[] = [];
    let maxPagesToShow = this.mobile ? 3 : 5; // Exibir menos páginas no mobile

    // Ajustar início e fim da paginação
    let startPage = Math.max(1, this.buscaResponse?.page - Math.floor(maxPagesToShow / 2));
    let endPage = Math.min(totalPaginas, startPage + maxPagesToShow - 1);

    // Ajuste quando estiver perto do final
    if (endPage - startPage < maxPagesToShow - 1) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }

    // Criar o array de páginas
    for (let i = startPage; i <= endPage; i++) {
      pagesArray.push(i);
    }

    return pagesArray;
  }

  getSvgColor(): string {
    return this.buscaResponse?.page === 1 ? '#e0e0e0' : '#c70000';
  }

  getSvgColorEnd(): string {
    const totalPaginas = this.buscaResponse?.totalPages;
    return this.pageIndex === totalPaginas ? '#e0e0e0' : '#c70000';
  }
}
